<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">菜谱信息</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-table :data="dataList" height="400" border>

          <el-table-column label="详情" prop="type">
            <template slot-scope="scope">

              <div>早餐</div>
              <div style="padding-left: 30px;" v-for="(item,index) in scope.row.dishesPlanMorningDTO.listDishesPlanMorningItem" :key="index">
                <span v-show="item.dishesName">菜品：{{item.dishesName}}<br></span>
              </div>
              <div>午餐</div>
              <div style="padding-left: 30px;" v-for="(item,index) in scope.row.dishesPlanNoonDTO.listDishesPlanNoonItem" :key="index">
                <span v-show="item.dishesName">菜品：{{item.dishesName}}<br></span>
              </div>
              <div>晚餐</div>
              <div style="padding-left: 30px;" v-for="(item,index) in scope.row.dishesPlanNightDTO.listDishesPlanNightItem" :key="index">
                <span v-show="item.dishesName">菜品：{{item.dishesName}}<br></span>
              </div>


            </template>
          </el-table-column>
          <el-table-column label="时间" :formatter="timefilter" prop="time"></el-table-column>
          <el-table-column label="星期" prop="day"></el-table-column>
        </el-table>

      </div>
    </div>
  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Add",
  props:['dataList'],
  data() {
    return {

      loading: false,
      add_waresCode:'',
      pageSize:20,
      currentPage:1,
      showModalAdd:false,
      tableData:[],
      waresList:[],
      status:0,
      totalItems: 0,
      th:0,
      datetimerangeValue:[],
      statusValue:['老人状态','正常','禁用'],
      name:'',
      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        medicinerCode:'',
      },
      medicinerCode:'',
      rules:{
        name:[
          { required: true, message: '物品名称', trigger: 'blur' },
        ],
        sort:[
          { required: true, message: '请输入库存', trigger: 'blur' },
          { type: 'number', message: '库存必须为数字值'}
        ],
      }
    }
  },

  methods: {
    init(){

      const start= new Date();
      const end=new Date(start.getTime() + 1000 * 60 * 60 * 24 * 15);
      this.datetimerangeValue=[start, end];

    },
    closeSelf() {
      this.$emit("closeInfo");
    },

    timefilter(row, column, cellValue){
      return timefilters(cellValue).substring(0,10)
    },


  }
}
</script>

<style  lang="scss" scoped>

</style>
